import React, { useState, createRef, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { UiButton } from "./UiButton";
import CloseWhiteIcon from "../../../styles/img/svg/CloseWhiteIcon";
import UploadProfile from "../../../styles/img/upload-profile.png";
import { base64toBinary } from "../../../_helpers/support.services";
import {
    imageUploadRequest,
    profilePictureUploadRequest,
} from "../../../_redux/_actions";

export const UiCropFileUpload = (props) => {
    const [image, setImage] = useState();
    const [cropData, setCropData] = useState();
    const [alertShow, setAlertShow] = useState(false);

    const cropperRef = createRef();

    const actionDispatch = useDispatch();
    const hiddenFileInput = useRef(null);

    const { minWidth } = props;

    const onChange = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
            setImage(reader.result);
        };
        reader.readAsDataURL(files[0]);
    };

    const getCropData = () => {
        if (typeof cropperRef.current?.cropper !== "undefined") {
            const imageData = cropperRef.current?.cropper
                .getCroppedCanvas()
                .toDataURL();
            setCropData(imageData);

            if (
                cropperRef.current?.cropper.getCropBoxData().width <=
                `${minWidth}`
            ) {
                setCropData();
                setAlertShow(true);
                setTimeout(() => {
                    setAlertShow(false);
                }, 5000);
            }
        }

        if (cropperRef && cropperRef.current) {
            const cropper = cropperRef.current.cropper;
            if (cropper) {
                const canvas = cropper.getCroppedCanvas();
                if (canvas) {
                    try {
                        const base64 = canvas.toDataURL();

                        const timestamp = new Date()
                            .toISOString()
                            .replace(/[-:.]/g, "");
                        const randomNum = Math.floor(Math.random() * 1000000);

                        const filename = `file_${timestamp}_${randomNum}.png`;
                        const mimeType = "image/png";

                        const file = base64toBinary(base64, filename, mimeType);

                        actionDispatch(
                            imageUploadRequest({
                                file,
                                setUploadValue: props.setUploadValue,
                                setCropImageArea: props.setCropImageArea,
                            }),
                        );
                    } catch (error) {
                        console.error(
                            "Error converting canvas to Base64:",
                            error,
                        );
                    }
                } else {
                    console.error("Canvas is null or undefined.");
                }
            }
        }
    };

    const handleReset = () => {
        setCropData();
        props.setUploadValue("");
    };

    useEffect(() => {
        if (props.setToDefault) {
            handleReset();
            setImage(null);
        }
    }, [props.setToDefault]);

    useEffect(() => {
        if (props.defaultImage) {
            setCropData(props.defaultImage);
        }
    }, [props.defaultImage, props.setToDefault]);

    const handleClick = () => {
        hiddenFileInput.current.click();
    };

    return (
        <>
            {!cropData && (
                <div className="sba-file-upload-button-wr">
                    <input
                        type="file"
                        onChange={onChange}
                        accept="image/*"
                        ref={hiddenFileInput}
                        style={{ display: "none" }}
                    />

                    <span onClick={handleClick}>
                        {" "}
                        <img src={UploadProfile} /> Upload Photo
                    </span>
                    {/* <h5>{uploadSize}</h5> */}
                </div>
            )}
            <div className="sba-file-upload-row">
                {cropData && (
                    <div className="sba-cropped-image">
                        <img src={cropData} />
                        <span onClick={handleReset}>
                            <CloseWhiteIcon />
                        </span>
                    </div>
                )}

                <div className="sba-file-upload-section">
                    {!cropData && (
                        <Cropper
                            ref={cropperRef}
                            preview=".img-preview"
                            src={image}
                            aspectRatio={1 / 1}
                            movable={true}
                            background={false}
                            guides={false}
                            style={{ maxHeight: 320, width: "100%" }}
                            dragMode="move"
                            cropBoxMovable={false}
                            cropBoxResizable={false}
                        />
                    )}
                </div>
                {image && !cropData && (
                    <>
                        <div className="sba-crop-img-area">
                            <UiButton
                                onClick={getCropData}
                                title="Save Image"
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default UiCropFileUpload;
